var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaintenanceIllustrationEon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 717,
    height: 353,
    fill: "none",
    viewBox: "0 0 717 353",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M112 81C86.5 82.8333 29.8 72.4 7 16",
    stroke: "#3788B8",
    strokeWidth: 14,
    style: {
      stroke: "#c73b24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m605.86 269.38c25.522 1.495 82.079-9.687 104.13-66.384",
    stroke: "#3788B8",
    strokeWidth: 14,
    style: {
      stroke: "#c73b24"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m637.11 340.33c0 1.533-.303 3.051-.891 4.467-.588 1.417-1.449 2.703-2.536 3.787-1.086 1.084-2.376 1.944-3.795 2.531-1.42.586-2.941.888-4.478.888h-476.09c-3.103 0-6.079-1.23-8.273-3.419s-3.427-5.158-3.427-8.254c0-1.533.303-3.051.891-4.467s1.449-2.703 2.536-3.787c1.086-1.084 2.376-1.944 3.796-2.531 1.419-.586 2.94-.888 4.477-.888h476.09c1.537 0 3.058.302 4.478.888 1.419.587 2.709 1.447 3.795 2.531 1.087 1.084 1.949 2.371 2.537 3.787.587 1.416.89 2.934.89 4.467z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m355.4 36.87-.039-.0066 21.236-5.2478c.032.0258.075.0605.127.1039.126.1068.303.2662.502.4743.4.417.886 1.026 1.239 1.7967.351.7694.57 1.6989.438 2.7632-.13 1.0492-.601 2.2435-1.644 3.5557-.041 7e-4-.1-.001-.178-.006-.175-.0109-.427-.0362-.749-.0745-.643-.0763-1.549-.2027-2.632-.3636-2.165-.3218-5.028-.7803-7.884-1.2489-2.856-.4685-5.704-.9469-7.838-1.3082-1.067-.1806-1.956-.332-2.578-.4382z",
    fill: "#353535",
    stroke: "#353535",
    strokeWidth: 0.39747
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m354.38 36.899 22.251-5.4988s5.102 3.6579.728 9.0904c-.255.3147-22.979-3.5916-22.979-3.5916z",
    stroke: "#353535",
    strokeMiterlimit: 10,
    strokeWidth: 1.1924
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m352.41 23.92-.036.0181 14.033-16.745c.042.0015.097.00417.164.00893.166.01172.403.03605.687.08654.569.10114 1.322.30625 2.063.72072.739.4137 1.466 1.0352 1.989 1.9717.516.9232.842 2.1646.777 3.8378-.032.0244-.081.0576-.147.0997-.147.094-.366.2225-.649.3813-.564.317-1.37.7488-2.339 1.2567-1.937 1.0156-4.52 2.3323-7.102 3.6368-2.582 1.3044-5.164 2.5962-7.1 3.562-.968.4829-1.775.8842-2.34 1.1648z",
    fill: "#353535",
    stroke: "#353535",
    strokeWidth: 0.39747
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m351.62 24.539 14.705-17.546s6.283-.05357 5.966 6.9075c-.019.4035-20.671 10.639-20.671 10.639z",
    stroke: "#353535",
    strokeMiterlimit: 10,
    strokeWidth: 1.1924
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m342.6 25.624-6.718-21.868s3.381-5.2823 9.057-1.2211c.329.23621-2.339 23.089-2.339 23.089z",
    fill: "#3788B8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m342.6 25.624-6.718-21.868s3.381-5.2823 9.057-1.2211c.329.23621-2.339 23.089-2.339 23.089z",
    fill: "#353535",
    stroke: "#353535",
    strokeMiterlimit: 10,
    strokeWidth: 1.1924
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m384.64 318.5-20.107 1.571s-3.899-3.908.683-7.993c.265-.237 19.424 6.422 19.424 6.422z",
    fill: "#353535"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m384.64 318.5-20.107 1.571s-3.899-3.908.683-7.993c.265-.237 19.424 6.422 19.424 6.422z",
    stroke: "#353535",
    strokeMiterlimit: 10,
    strokeWidth: 1.1924
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m385.26 329.62-15.298 13.113s-5.46-.857-4.181-6.854c.075-.347 19.479-6.259 19.479-6.259z",
    fill: "#353535"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "m385.26 329.62-15.298 13.113s-5.46-.857-4.181-6.854c.075-.347 19.479-6.259 19.479-6.259z",
    stroke: "#353535",
    strokeMiterlimit: 10,
    strokeWidth: 1.1924
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m393.24 329.98 2.67 19.945s-3.698 4.098-8.038-.243c-.251-.252 5.368-19.702 5.368-19.702z",
    fill: "#353535"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m393.24 329.98 2.67 19.945s-3.698 4.098-8.038-.243c-.251-.252 5.368-19.702 5.368-19.702z",
    stroke: "#353535",
    strokeMiterlimit: 10,
    strokeWidth: 1.1924
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m294.29 225.84h-3.021l-1.257 7.675h-3.734l1.258-7.675h-4.166v-3.425h4.728l.826-4.943h-4.147v-3.425h4.71l1.294-7.788h3.715l-1.275 7.788h3.02l1.295-7.788h3.734l-1.295 7.788h4.334v3.425h-4.897l-.826 4.943h4.297v3.425h-4.859l-1.257 7.675h-3.734l1.257-7.675zm-2.458-3.425h3.021l.825-4.943h-3.021l-.825 4.943z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m150.46 327.69h466.74",
    stroke: "#3788B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.1924,
    style: {
      stroke: "#c73b24"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m236.67 313.54-4.034 12.216-9.143-.249 3.021-10.171",
    fill: "#B78876"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m236.67 313.54-4.034 12.216-9.143-.249 3.021-10.171",
    stroke: "#B78876",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.1924
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m271.17 128.81-5.555.463c1.35 11.323-3.47 19.687-9.791 25.665l6.126 9.62c10.995-14.503 9.22-35.748 9.22-35.748z",
    fill: "#B78876",
    stroke: "#B78876",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.1924
  })), /*#__PURE__*/React.createElement("path", {
    d: "m232.99 167.64 5.137 9.844c11.392-1.264 18.894-6.415 23.828-12.923l-6.126-9.62c-9.665 9.141-22.839 12.699-22.839 12.699z",
    fill: "white",
    stroke: "#3788B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.1924,
    style: {
      stroke: "#c73b24"
    }
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m271.09 131.29-5.15-.089c-.217-.133-.416-.292-.592-.475-.27-.288.292-1.316.292-1.316s-1.906-2.977-2.34-5.518c-.435-2.542-2.452-5.04-1.235-5.073s1.276 2.154 1.879 1.894c.301-.129.401-2.131.058-4.083-.342-1.95-1.127-3.851-.269-3.692 1.714.318 2.642 6.573 2.642 6.573s.127-2.016.118-4.126c-.008-2.263-.116-4.629.958-4.614.927.013.911 2.093 1.161 4.165.178 1.363.435 2.716.768 4.05 0 0 .457-6.84 1.208-6.132.751.709.208 6.789.644 6.787.437-.003.974-4.258 1.593-3.91s-.035 7.66-.035 7.66.235 4.287-1.416 6.277c0 0 .735 1.311-.284 1.622z",
    fill: "#FFC933"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m258.86 151.86-5.496 3.429 7.728 12.328 5.496-3.429-7.728-12.328z",
    fill: "white",
    stroke: "#3788B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.1924,
    style: {
      stroke: "#c73b24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m187.65 80.364c-.001 3.2686-1.302 6.4034-3.618 8.7148-2.317 2.3115-5.459 3.6102-8.735 3.6107h-58.517c-3.277-2e-4-6.419-1.2989-8.735-3.6103-2.317-2.3114-3.619-5.4463-3.619-8.7152s1.302-6.4039 3.618-8.7154c2.317-2.3115 5.459-3.6102 8.736-3.6105h58.517c3.277 5e-4 6.418 1.2993 8.735 3.6108 2.316 2.3115 3.618 5.4464 3.618 8.7151z",
    fill: "white",
    stroke: "#3788B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.1924,
    style: {
      stroke: "#c73b24"
    }
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m171.54 82.872h-52.964c-2.527-.0012-4.978-.8564-6.956-2.4261-1.977-1.5698-3.362-3.7614-3.931-6.2177-.918 1.6997-1.378 3.6078-1.335 5.5379.043 1.93.587 3.816 1.579 5.4736.992 1.6575 2.398 3.03 4.08 3.9832 1.683.9532 3.585 1.4545 5.519 1.455h52.965c1.683.0045 3.346-.3714 4.863-1.0994 1.517-.7281 2.849-1.7893 3.896-3.1043 1.048-1.315 1.783-2.8495 2.151-4.4884.368-1.639.36-3.3398-.025-4.975-.957 1.7725-2.378 3.2533-4.111 4.2852-1.732 1.0319-3.713 1.5765-5.731 1.576z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m213.66 84.903c0 3.0245-.596 6.0195-1.756 8.8138-1.16 2.7944-2.86 5.3335-5.004 7.4718-2.143 2.139-4.688 3.835-7.489 4.993-2.8 1.157-5.802 1.753-8.833 1.752-3.032 0-6.033-.595-8.834-1.752-2.801-1.158-5.345-2.854-7.489-4.993-2.143-2.1384-3.843-4.6774-5.003-7.4718s-1.756-5.7893-1.756-8.8138v-9.081c0-3.0244.597-6.0193 1.756-8.8135 1.16-2.7943 2.86-5.3333 5.004-7.4719 2.143-2.1386 4.688-3.835 7.488-4.9924 2.801-1.1573 5.802-1.7528 8.834-1.7526 3.031-2e-4 6.033.5953 8.833 1.7526 2.801 1.1573 5.345 2.8537 7.489 4.9924 2.143 2.1386 3.844 4.6775 5.003 7.4718 1.16 2.7943 1.757 5.7892 1.757 8.8136v9.081z",
    fill: "white",
    stroke: "#3788B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.1924,
    style: {
      stroke: "#c73b24"
    }
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m197.49 95.573c-2.684 3e-4-5.341-.5269-7.821-1.5514-2.479-1.0246-4.732-2.5264-6.63-4.4198-1.897-1.8933-3.402-4.1411-4.429-6.6149-1.027-2.4739-1.555-5.1253-1.555-7.8028v-8.0399c-.002-2.6427.513-5.2605 1.515-7.7068-2.775 1.8658-5.047 4.3834-6.618 7.3313-1.57 2.9479-2.39 6.2357-2.388 9.5741v8.0399c0 4.726 1.646 9.3052 4.656 12.955 3.009 3.6495 7.196 6.1425 11.844 7.0525s9.469.181 13.638-2.063c4.169-2.243 7.427-5.8625 9.217-10.238-3.374 2.2771-7.356 3.4909-11.429 3.4841z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m289.08 97.879c0 3.4082-.672 6.7822-1.979 9.9302-1.307 3.149-3.223 6.009-5.638 8.419s-5.282 4.321-8.438 5.625-6.538 1.975-9.953 1.974h-46.164c-3.416 0-6.798-.671-9.953-1.975s-6.023-3.215-8.438-5.624c-2.415-2.41-4.33-5.271-5.637-8.419s-1.98-6.523-1.98-9.9302v-35.032c0-3.4076.673-6.7819 1.98-9.9302 1.307-3.1482 3.223-6.0088 5.638-8.4183s5.282-4.3209 8.437-5.6248c3.156-1.304 6.537-1.9751 9.953-1.975h46.164c3.415-3e-4 6.797.6706 9.953 1.9745 3.155 1.3039 6.023 3.2152 8.438 5.6248s4.331 5.2702 5.638 8.4185c1.307 3.1484 1.979 6.5227 1.979 9.9305v35.032z",
    fill: "white",
    stroke: "#3788B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.1924,
    style: {
      stroke: "#c73b24"
    }
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m271.82 108.5h-42.908c-3.174 0-6.318-.623-9.251-1.835-2.932-1.212-5.597-2.989-7.842-5.228-2.245-2.24-4.025-4.8989-5.24-7.8251-1.215-2.9263-1.84-6.0626-1.84-9.2299v-32.561c-.002-3.0276.57-6.0282 1.685-8.8442-3.975 2.0175-7.313 5.0931-9.644 8.8864-2.332 3.7932-3.566 8.1562-3.565 12.606v32.561c0 3.1668.625 6.3038 1.84 9.2298 1.214 2.926 2.995 5.585 5.24 7.825 2.244 2.239 4.909 4.016 7.842 5.228s6.076 1.835 9.251 1.835h42.907c4.852 0 9.592-1.457 13.602-4.181 4.011-2.724 7.108-6.589 8.887-11.092-3.395 1.729-7.153 2.629-10.964 2.625z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m293.1 19.707c-3.701-.0282-7.375.6201-10.842 1.9126-.048-.001-.095-.0059-.142-.0059-2.118 0-4.146 1.3124-6.02 3.7106-1.677 1.5663-2.784 3.3785-3.142 5.329-4.879 10.518-8.124 29.183-8.124 50.461 0 32.861 7.739 59.5 17.286 59.5.922-.009 1.829-.246 2.638-.689 2.72.735 5.527 1.103 8.346 1.094 11.198 0 20.278-5.52 20.278-12.326v-96.659c0-6.8075-9.08-12.327-20.278-12.327z",
    fill: "white",
    stroke: "#3788B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.1924,
    style: {
      stroke: "#c73b24"
    }
  }), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m252.88 96.382c0 .4018-.16.7872-.445 1.0714-.285.2841-.671.4438-1.074.4439-.401-.0013-.786-.1616-1.07-.4456-.284-.2841-.443-.6688-.442-1.0697v-37.626c0-.4001.16-.7835.444-1.0665.283-.2829.667-.4423 1.068-.4433.402-2e-4.788.1586 1.073.4416.284.2831.445.6672.446 1.0682v37.626z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m241.94 96.382c0 .4018-.16.7871-.445 1.0713s-.671.4439-1.073.444c-.402-.0013-.787-.1615-1.071-.4456-.284-.284-.443-.6687-.443-1.0697v-37.626c.001-.4001.161-.7836.445-1.0665.283-.283.667-.4423 1.069-.4433.401-2e-4.787.1587 1.072.4417.284.283.445.6672.446 1.0681v37.626z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m322.45 81.114c0 32.861-7.739 59.5-17.286 59.5-9.546 0-17.285-26.639-17.285-59.5 0-32.862 7.739-59.5 17.285-59.5 9.547 0 17.286 26.639 17.286 59.5z",
    fill: "#3788B8",
    stroke: "#3788B8",
    strokeMiterlimit: 10,
    strokeWidth: 1.1924,
    style: {
      fill: "#c73b24",
      stroke: "#c73b24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m301.14 90.543c0 .6099-.243 1.1948-.675 1.6261-.432.4312-1.019.6735-1.63.6735-.302 0-.602-.0594-.882-.175-.28-.1155-.534-.2849-.748-.4985-.214-.2135-.383-.467-.499-.746-.116-.2791-.176-.5781-.176-.8801v-20.122c0-.302.06-.601.176-.88s.285-.5325.499-.7461c.214-.2135.468-.3829.748-.4985s.58-.175.882-.175c.612 0 1.198.2423 1.63.6736.432.4312.675 1.0161.675 1.626v20.122z",
    fill: "#3788B8",
    style: {
      fill: "#ffb6ae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m314.1 82.782c0 .6099-.243 1.1948-.675 1.626-.433.4313-1.019.6736-1.63.6737-.611-1e-4-1.197-.2425-1.63-.6737-.432-.4313-.675-1.0161-.675-1.626v-20.122c0-.6099.243-1.1948.675-1.626.433-.4313 1.019-.6736 1.63-.6737.611 1e-4 1.198.2423 1.63.6736s.675 1.0162.675 1.6261v20.122z",
    fill: "#3788B8",
    style: {
      fill: "#ffb6ae"
    }
  }), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m265.92 308.22-1.801 10.42-9.94 1.581 2.234-10.205",
    fill: "#B78876"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m265.92 308.22-1.801 10.42-9.94 1.581 2.234-10.205",
    stroke: "#B78876",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.1924
  })), /*#__PURE__*/React.createElement("path", {
    d: "m220.55 162.55s-14.988 2.242-13.788 16.748c.406 4.918 8.842 47.402 8.842 47.402l39.343-3.737s-10.567-54.133-17.311-58.619-17.086-1.794-17.086-1.794z",
    fill: "#3788B8",
    style: {
      fill: "#c73b24"
    }
  }), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m215.6 226.7s1.899 12.003 6.144 23.327c6.398 17.062 11.879 25.54 10.342 38.188-2.302 18.947-9.532 29.633-9.532 29.633l16.639 2.658s10.371-34.782 8.835-39.764c-2.697-23.328-5.186-59.408-5.186-59.408l-27.242 5.366z",
    fill: "#353535"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m252.25 217.06s19.854 28.902 20.753 49.314c.733 16.636-5.858 46.592-5.858 46.592l-13.898-.438s4.967-38.106 1.894-47.304c-8.992-16.149-22.473-35.836-22.473-35.836l19.582-12.328z",
    fill: "#353535"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m216.5 168.72s10.116-3.028 13.938 7.29.443 17.574-5.701 18.68c-12.818 2.31-21.951-24.399-8.237-25.97z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m241.12 177.81c.344 1.071-4.159 3.806-4.159 3.806-.698-1.81-1.542-3.56-2.523-5.233-.802-1.313-1.716-2.555-2.732-3.711-1.714-1.598-3.963-3.841-6.481-4.952-.915-.423-1.866-.761-2.843-1.01-2.013-.515-2.142-2.547-.09-2.898 1.015-.306 2.073-.447 3.133-.416 1.072.032 2.136.192 3.169.477 1.084.22 2.138.563 3.143 1.023.986.462 1.928 1.011 2.817 1.64.964.59 4.643 5.285 6.566 11.274z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m220.92 144.52-1.532 9.88-6.938-6.355-2.464-4.908 2.772-2.611s10.471-8.451 12.166-10.371c1.693-1.921 7.235 8.822 2.462 13.278",
    fill: "#353535"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m218.22 152.68.862 12.112s4.327 2.188 6.8 1.851c1.462-.193 2.795-.938 3.724-2.081l-4.005-11.807-7.381-.075z",
    fill: "#B78876",
    stroke: "#B78876",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.1924
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m226.44 141.14-7.419 2.923s.773 3.37.612 3.761c-.002.001-2.121 1.279-2.121 1.279-1.031.712-1.13 2.346-.223 3.652.907 1.305 2.476 1.785 3.506 1.072.234-.166.426-.383.562-.635 2.134 2.156 3.67 3.141 6.492 3.141 5.351 0-1.409-15.193-1.409-15.193z",
    fill: "#B78876",
    stroke: "#B78876",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.79495
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m246.18 128.49h-4.271c.497 9.6-4.54 18.472-10.316 25.478l7.574 6.281c7.286-15.371 7.013-31.759 7.013-31.759z",
    fill: "#B78876",
    stroke: "#B78876",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.1924
  })), /*#__PURE__*/React.createElement("path", {
    d: "m215.11 169.08c-1.013 1.195-1.89 2.496-2.618 3.881-1.39 2.61-1.39 6.207.859 7.552 7.194 4.936 13.939-3.125 18.289-8.366.899-1.09 1.738-2.189 2.527-3.351.789-1.161 1.528-2.295 2.22-3.504.509-.835.99-1.555 1.446-2.406.47-.873.909-1.753 1.327-2.636l-7.574-6.281c-.105.127-14.188 12.623-16.476 15.111z",
    fill: "white",
    stroke: "#3788B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.1924,
    style: {
      stroke: "#c73b24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m232.83 149.15-4.146 4.971 11.202 9.301 4.146-4.971-11.202-9.301z",
    fill: "white",
    stroke: "#3788B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.1924,
    style: {
      stroke: "#c73b24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m250.78 212.64s-24.017 6.621-36.926 5.032l.943 11.52s24.943-6.119 36.62-12.211c.206-.108.01-.654.01-.654l-.647-3.687z",
    fill: "white",
    stroke: "#3788B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.1924,
    style: {
      stroke: "#c73b24"
    }
  }), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m261.92 326.14-.899-1.121-8.872-.596-.757 2.427s25.74 2.917 26.19 1.009c.144-.609.287-.965.239-1.272l-15.901-.447z",
    fill: "#353535",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.1924
  })), /*#__PURE__*/React.createElement("path", {
    d: "m261.92 326.14 15.902.447c-.1-.653 1.016-1.357-2.657-3.494-1.992-1.159-6.197-1.225-7.699-2.355-1.571-1.199-2.895-2.691-3.897-4.392 0 0-3.41 4.149-5.321 3.364-1.91-.785-4.158-1.495-4.158-1.495l-1.941 6.208 8.872.596.899 1.121z",
    fill: "#3788B8",
    stroke: "#3788B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.1924,
    style: {
      fill: "#c73b24",
      stroke: "#c73b24"
    }
  }), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m230.82 332.76-.855-1.155-8.842-.939-.852 2.396s25.609 3.911 26.132 2.023c.168-.604.324-.954.289-1.262l-15.872-1.063z",
    fill: "#353535",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.1924
  })), /*#__PURE__*/React.createElement("path", {
    d: "m230.82 332.76 15.872 1.062c-.075-.656 1.068-1.316-2.518-3.594-1.946-1.235-6.146-1.464-7.603-2.651-1.523-1.26-2.788-2.802-3.723-4.541 0 0-3.568 4.015-5.447 3.156s-4.098-1.655-4.098-1.655l-2.18 6.129 8.841.939.856 1.155z",
    fill: "#3788B8",
    stroke: "#3788B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.1924,
    style: {
      fill: "#c73b24",
      stroke: "#c73b24"
    }
  }), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m246.82 130.42-5.233-.233c-.217-.141-.415-.309-.589-.499-.267-.299.333-1.33.333-1.33s-1.855-3.08-2.227-5.676-2.355-5.192-1.116-5.192c1.24 0 1.24 2.226 1.86 1.978.309-.123.466-2.156.172-4.15-.294-1.993-1.04-3.947-.172-3.761 1.734.37 2.505 6.755 2.505 6.755s.184-2.046.233-4.191c.055-2.301.01-4.71 1.102-4.665.943.038.868 2.153 1.065 4.267.144 1.391.367 2.773.669 4.138 0 0 .655-6.942 1.398-6.201.744.741.023 6.909.467 6.918s1.109-4.302 1.729-3.931c.62.37-.248 7.787-.248 7.787s.12 4.367-1.614 6.344c0 0 .711 1.353-.334 1.642z",
    fill: "#FFC933"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m239.89 188.06c.552 1.432.518 2.778-.076 3.006s-1.523-.749-2.076-2.181c-.551-1.433-.518-2.779.077-3.007.593-.227 1.522.749 2.075 2.182z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "m244.78 185.09c.552 1.432.518 2.778-.076 3.006-.594.227-1.523-.749-2.075-2.181-.552-1.433-.518-2.779.077-3.007.593-.227 1.521.749 2.074 2.182z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "m213.46 216.35h9.604c.764 0 1.497.302 2.037.842.541.539.844 1.27.844 2.032v19.355c0 .762-.303 1.494-.843 2.033-.541.539-1.274.841-2.038.841h-9.604c-.764 0-1.497-.302-2.037-.841s-.844-1.271-.844-2.033v-19.355c0-.762.304-1.493.844-2.032.54-.54 1.273-.842 2.037-.842z",
    fill: "#E6E6E6",
    stroke: "#E6E6E6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.1924
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "m138.24 195.58c0 .411-.122.812-.351 1.154s-.554.608-.934.765c-.381.158-.8.199-1.204.119-.404-.081-.775-.279-1.066-.569-.291-.291-.489-.661-.57-1.064-.08-.403-.039-.821.119-1.2.157-.38.424-.705.767-.933.342-.228.745-.35 1.157-.35.552 0 1.082.219 1.472.609.391.389.61.918.61 1.469z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "m150.09 195.58c0 .411-.122.812-.351 1.154s-.554.608-.935.765c-.38.158-.799.199-1.203.119-.404-.081-.775-.279-1.066-.569-.291-.291-.49-.661-.57-1.064s-.039-.821.118-1.2c.158-.38.425-.705.767-.933.343-.228.746-.35 1.157-.35.553 0 1.082.219 1.473.609.39.389.61.918.61 1.469z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "m161.93 195.58c0 .411-.122.812-.351 1.154-.228.342-.554.608-.934.765-.381.158-.8.199-1.204.118-.404-.08-.775-.278-1.066-.568-.291-.291-.489-.661-.57-1.065-.08-.403-.038-.821.119-1.2.158-.38.425-.704.768-.932.342-.229.745-.35 1.157-.35.274 0 .544.054.797.158.252.105.482.258.675.451s.347.422.451.674c.105.252.158.522.158.795z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "m173.78 195.58c0 .411-.122.812-.351 1.154s-.554.608-.934.765c-.381.157-.8.199-1.204.118-.404-.08-.775-.278-1.066-.568-.291-.291-.489-.661-.57-1.064-.08-.403-.039-.821.119-1.2.157-.38.424-.705.767-.933.342-.228.745-.35 1.157-.35.273 0 .544.054.797.158.252.104.482.257.675.45.194.193.347.422.452.674.104.253.158.523.158.796z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "m185.63 195.58c0 .411-.123.812-.351 1.154-.229.342-.554.608-.935.765-.38.157-.799.199-1.203.118-.404-.08-.775-.278-1.066-.568-.292-.291-.49-.661-.57-1.064s-.039-.821.118-1.201c.158-.379.425-.704.767-.932.343-.228.746-.35 1.157-.35.553 0 1.082.219 1.473.609.39.389.609.918.61 1.469z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "m197.48 195.58c0 .411-.122.812-.351 1.154s-.554.608-.934.765c-.381.158-.8.199-1.204.118-.404-.08-.775-.278-1.066-.569-.291-.29-.489-.661-.57-1.064-.08-.403-.038-.821.119-1.2.158-.38.425-.704.768-.932.342-.229.745-.35 1.157-.35.552 0 1.082.219 1.472.609.39.389.609.918.609 1.469z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "m138.24 208.5c0 .411-.122.813-.35 1.155-.229.342-.554.608-.935.766-.38.157-.799.198-1.203.118s-.775-.278-1.067-.568c-.291-.291-.489-.661-.57-1.064-.08-.403-.039-.821.119-1.201.157-.379.424-.704.767-.932.342-.228.745-.35 1.157-.35.552 0 1.081.219 1.471.608.391.39.61.918.611 1.468z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "m150.09 208.5c0 .411-.122.813-.351 1.155-.228.342-.554.608-.934.766-.381.157-.799.198-1.203.118s-.776-.278-1.067-.568c-.291-.291-.49-.661-.57-1.064s-.039-.821.118-1.201c.158-.379.425-.704.767-.932.343-.228.746-.35 1.157-.35.552 0 1.082.219 1.472.608.391.39.61.918.611 1.468z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "m161.93 208.5c.001.411-.121.813-.35 1.155s-.554.608-.935.766c-.38.157-.799.198-1.203.118s-.775-.278-1.067-.568c-.291-.291-.489-.661-.57-1.065-.08-.403-.038-.821.119-1.2.158-.38.425-.704.768-.933.342-.228.745-.349 1.157-.349.552 0 1.081.219 1.471.609.391.389.61.917.61 1.467z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "m173.78 208.5c0 .411-.122.813-.351 1.155-.228.342-.553.608-.934.766-.38.157-.799.198-1.203.118s-.775-.278-1.067-.568c-.291-.291-.489-.661-.57-1.064-.08-.403-.039-.821.119-1.201.157-.379.424-.704.767-.932.342-.228.745-.35 1.157-.35.552 0 1.081.219 1.472.608.39.39.61.918.61 1.468z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "m185.63 208.5c0 .411-.122.813-.351 1.155s-.554.608-.934.766c-.381.157-.8.198-1.204.118s-.775-.278-1.066-.568c-.291-.291-.49-.661-.57-1.064-.081-.403-.039-.821.118-1.201.158-.379.425-.704.767-.932.343-.228.745-.35 1.157-.35.552 0 1.082.219 1.472.608.39.39.61.918.611 1.468z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "m197.48 208.5c.001.411-.121.813-.35 1.155s-.554.608-.935.766c-.38.157-.799.198-1.203.118s-.775-.278-1.067-.568c-.291-.291-.489-.661-.57-1.065-.08-.403-.038-.821.119-1.2.158-.38.425-.704.768-.933.342-.228.745-.349 1.157-.349.552 0 1.081.219 1.471.609.39.389.61.917.61 1.467z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "m138.24 221.43c0 .411-.122.812-.351 1.154s-.555.608-.935.765c-.381.157-.799.198-1.203.118s-.775-.278-1.066-.569-.49-.661-.57-1.064-.039-.821.119-1.2c.157-.38.424-.704.767-.932.342-.229.745-.351 1.157-.351.273 0 .544.054.797.159.252.104.482.257.675.45.194.193.347.422.452.675.104.252.158.522.158.795z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "m150.09 221.43c0 .411-.123.812-.352 1.154s-.554.608-.934.765c-.381.157-.8.198-1.203.118-.404-.08-.775-.278-1.067-.569-.291-.291-.489-.661-.569-1.064s-.039-.821.119-1.2c.157-.38.424-.704.767-.932.342-.229.745-.351 1.156-.351.274 0 .545.054.798.159.252.104.482.257.675.45.194.193.347.422.451.675.105.252.159.522.159.795z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "m161.93 221.43c0 .411-.122.813-.351 1.154-.229.342-.554.608-.935.765s-.799.198-1.203.118c-.404-.081-.775-.279-1.066-.569-.291-.291-.489-.661-.57-1.064-.08-.404-.038-.821.119-1.201.158-.379.425-.704.768-.932s.745-.35 1.157-.35c.274.001.544.054.797.159.253.104.482.257.675.45.194.193.347.423.451.675.105.252.159.522.158.795z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "m173.78 221.43c0 .411-.122.812-.351 1.154s-.555.608-.935.765c-.381.157-.799.198-1.203.118-.404-.081-.775-.278-1.066-.569s-.49-.661-.57-1.064-.039-.821.119-1.2c.157-.38.424-.704.767-.932.342-.229.745-.351 1.157-.351.273 0 .544.054.797.159.253.104.482.257.676.45.193.193.346.422.451.674.104.253.158.523.158.796z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "m185.63 221.43c-.001.411-.123.812-.352 1.154s-.554.608-.935.765c-.38.157-.799.198-1.203.118-.403-.081-.774-.279-1.066-.569-.291-.291-.489-.661-.569-1.064s-.039-.821.118-1.2c.158-.38.425-.704.768-.933.342-.228.745-.35 1.156-.35.274.001.545.054.797.159.253.104.483.257.676.45s.347.422.451.675c.105.252.159.522.159.795z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "m197.48 221.43c0 .411-.122.813-.351 1.154-.229.342-.554.608-.935.765s-.799.198-1.203.118c-.404-.081-.775-.279-1.066-.569-.291-.291-.49-.661-.57-1.065-.08-.403-.038-.82.119-1.2.158-.38.425-.704.768-.932s.745-.35 1.157-.35c.274.001.544.054.797.159.252.104.482.258.675.451s.347.422.451.674c.105.252.158.522.158.795z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "m138.24 234.36c0 .411-.122.813-.351 1.154-.229.342-.554.608-.934.766-.381.157-.799.198-1.203.118s-.776-.278-1.067-.568c-.291-.291-.489-.661-.57-1.064-.08-.403-.039-.821.119-1.201.157-.379.424-.704.767-.932.342-.228.745-.35 1.157-.35.273 0 .544.053.797.158.252.104.482.257.675.45.194.193.347.422.452.674.104.252.158.522.158.795z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "m150.09 234.36c0 .411-.122.813-.351 1.154-.229.342-.554.608-.935.766-.38.157-.799.198-1.203.118s-.775-.278-1.066-.568c-.291-.291-.49-.661-.57-1.064s-.039-.821.118-1.201c.158-.379.425-.704.767-.932.343-.228.746-.35 1.157-.35.274 0 .545.053.797.158.253.104.483.257.676.45s.347.422.451.674c.105.252.159.522.159.795z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "m161.93 234.36c0 .411-.122.813-.35 1.154-.229.342-.555.609-.935.766-.381.157-.799.198-1.203.118s-.776-.278-1.067-.569c-.291-.29-.489-.661-.57-1.064-.08-.403-.038-.821.119-1.2.158-.38.425-.705.768-.933.342-.228.745-.35 1.157-.349.274 0 .544.053.797.158.252.104.482.257.675.45s.347.422.451.674c.105.252.159.522.158.795z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "m173.78 234.36c0 .411-.122.813-.351 1.154-.229.342-.554.608-.934.766-.381.157-.8.198-1.203.118-.404-.08-.776-.278-1.067-.568-.291-.291-.489-.661-.57-1.064-.08-.403-.039-.821.119-1.201.157-.379.424-.704.767-.932.342-.228.745-.35 1.157-.35.273 0 .544.053.797.157.252.105.482.258.675.451.194.193.347.422.452.674.104.252.158.522.158.795z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "m185.63 234.36c0 .411-.122.813-.351 1.154-.229.342-.554.608-.935.766-.38.157-.799.198-1.203.118s-.775-.278-1.066-.569c-.291-.29-.49-.66-.57-1.063s-.039-.821.118-1.201c.158-.379.425-.704.767-.932.343-.229.746-.35 1.157-.35.274 0 .545.053.797.158.253.104.482.257.676.45.193.193.346.422.451.674s.159.522.159.795z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "m197.48 234.36c0 .411-.122.813-.351 1.154-.228.342-.554.609-.934.766-.381.157-.8.198-1.204.118s-.775-.278-1.066-.569c-.291-.29-.489-.661-.57-1.064-.08-.403-.038-.821.119-1.2.158-.38.425-.705.768-.933.342-.228.745-.35 1.157-.349.552 0 1.082.219 1.472.608.39.39.609.918.609 1.469z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m445.08 85.312c0 .3025-.09.5982-.258.8497-.169.2515-.408.4475-.688.5633s-.588.1461-.886.0871c-.297-.059-.57-.2046-.784-.4185-.215-.2139-.361-.4864-.42-.783-.059-.2967-.029-.6041.087-.8836.116-.2794.313-.5182.565-.6862s.548-.2576.852-.2576c.406 1e-4.796.1612 1.083.4479s.449.6755.449 1.0809z",
    fill: "#3788B8",
    style: {
      fill: "#c73b24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m453.8 85.312c0 .3025-.089.5981-.258.8496-.168.2514-.408.4474-.688.5632-.28.1157-.588.146-.885.087s-.57-.2046-.785-.4184c-.214-.2139-.36-.4863-.419-.7829s-.029-.6041.087-.8835.313-.5182.565-.6862.548-.2576.851-.2576c.406 1e-4.796.1612 1.083.4479.288.2867.449.6755.449 1.0809z",
    fill: "#3788B8",
    style: {
      fill: "#c73b24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m462.52 85.312c0 .3026-.09.5983-.259.8499-.168.2516-.407.4476-.687.5634-.281.1158-.589.1461-.886.0871-.298-.059-.571-.2048-.785-.4187-.215-.214-.36-.4866-.42-.7833-.059-.2967-.028-.6043.088-.8837.116-.2795.313-.5183.565-.6862.252-.168.549-.2575.852-.2573.406 1e-4.796.1613 1.083.448s.449.6755.449 1.0808z",
    fill: "#3788B8",
    style: {
      fill: "#c73b24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m471.24 85.312c0 .3025-.09.5982-.258.8497s-.408.4476-.688.5634c-.28.1157-.588.146-.886.087-.297-.059-.57-.2047-.784-.4186-.215-.2139-.361-.4864-.42-.7831-.059-.2966-.028-.6041.088-.8836.116-.2794.312-.5182.564-.6861.253-.168.549-.2576.852-.2575.201 0 .401.0396.586.1164.186.0768.355.1895.497.3314.143.142.256.3105.333.496s.116.3843.116.585z",
    fill: "#3788B8",
    style: {
      fill: "#c73b24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m479.96 85.312c0 .3025-.09.5981-.258.8496-.169.2515-.408.4476-.688.5634s-.588.1461-.886.0872c-.297-.059-.57-.2046-.784-.4184-.215-.2138-.361-.4862-.42-.7828-.059-.2967-.029-.6041.087-.8835.116-.2795.312-.5183.564-.6864s.549-.2578.852-.2579c.406 1e-4.796.1611 1.084.4478.287.2867.449.6755.449 1.081z",
    fill: "#3788B8",
    style: {
      fill: "#c73b24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m488.68 85.312c0 .3026-.09.5984-.258.85s-.408.4477-.688.5636c-.28.1158-.588.1461-.886.0871-.297-.059-.57-.2047-.785-.4187-.214-.214-.36-.4866-.419-.7833-.059-.2968-.029-.6044.087-.8838.116-.2795.313-.5184.565-.6863.252-.168.549-.2576.852-.2574.406 3e-4.796.1615 1.083.4482.287.2866.449.6753.449 1.0806z",
    fill: "#3788B8",
    style: {
      fill: "#c73b24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m445.08 94.827c0 .3025-.09.5982-.258.8498s-.408.4477-.688.5636-.588.1463-.885.0873c-.298-.0589-.571-.2045-.785-.4183-.215-.2139-.361-.4864-.42-.7831-.059-.2966-.029-.6041.087-.8836s.313-.5183.565-.6863c.252-.1681.548-.2577.852-.2577.406 2e-4.795.1613 1.083.4478.287.2866.449.6752.449 1.0805z",
    fill: "#3788B8",
    style: {
      fill: "#c73b24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m453.8 94.827c.001.3024-.089.5982-.258.8497-.168.2515-.407.4476-.687.5635-.28.1158-.588.1462-.886.0873-.297-.059-.57-.2046-.785-.4184-.214-.2138-.36-.4862-.419-.7829-.059-.2966-.029-.6041.087-.8835s.312-.5183.565-.6863c.252-.168.548-.2577.851-.2577.406 2e-4.796.1613 1.083.4478.287.2866.449.6752.449 1.0805z",
    fill: "#3788B8",
    style: {
      fill: "#c73b24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m462.52 94.827c0 .3026-.09.5984-.258.85-.169.2517-.408.4478-.688.5637s-.588.1463-.886.0873c-.297-.059-.571-.2047-.785-.4186s-.36-.4865-.419-.7833c-.06-.2967-.029-.6043.087-.8838s.313-.5183.565-.6862c.252-.168.549-.2576.852-.2574.406 2e-4.796.1613 1.083.4479.287.2865.448.6751.449 1.0804z",
    fill: "#3788B8",
    style: {
      fill: "#c73b24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m471.24 94.827c0 .3025-.089.5983-.258.8498-.168.2516-.407.4478-.688.5636-.28.1159-.588.1463-.885.0873-.298-.0589-.571-.2046-.785-.4184-.215-.2139-.361-.4864-.42-.7831s-.028-.6042.088-.8837c.116-.2794.312-.5183.564-.6863.252-.1679.549-.2576.852-.2575.406 1e-4.796.1612 1.083.4477.287.2866.449.6753.449 1.0806z",
    fill: "#3788B8",
    style: {
      fill: "#c73b24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m479.96 94.827c0 .3025-.09.5982-.258.8498-.168.2515-.408.4477-.688.5635-.28.1159-.588.1463-.885.0875-.297-.0589-.571-.2044-.785-.4182-.215-.2138-.361-.4863-.42-.7829s-.029-.6041.087-.8836c.116-.2794.312-.5183.564-.6864s.549-.2579.852-.258c.406 1e-4.796.1612 1.083.4477.288.2866.449.6752.45 1.0806z",
    fill: "#3788B8",
    style: {
      fill: "#c73b24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m488.68 94.827c0 .3026-.089.5984-.258.8501-.168.2517-.407.4479-.687.5638-.281.1159-.589.1463-.886.0874-.298-.059-.571-.2046-.786-.4186-.214-.2139-.36-.4865-.419-.7833-.059-.2967-.029-.6043.087-.8839.116-.2795.313-.5183.565-.6863s.549-.2576.852-.2575c.406 4e-4.796.1616 1.083.4481s.449.675.449 1.0802z",
    fill: "#3788B8",
    style: {
      fill: "#c73b24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m445.08 104.34c0 .303-.09.598-.258.85-.169.251-.408.447-.688.563s-.589.146-.886.087-.57-.205-.785-.419c-.214-.214-.36-.486-.419-.783-.059-.296-.029-.604.087-.883.116-.28.313-.518.565-.686s.548-.258.852-.258c.406 0 .796.161 1.083.448.288.287.449.676.449 1.081z",
    fill: "#3788B8",
    style: {
      fill: "#c73b24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m453.8 104.34c0 .303-.09.598-.258.85-.168.251-.408.447-.688.563-.28.115-.588.146-.885.087-.298-.059-.571-.205-.785-.419s-.36-.486-.419-.783c-.059-.296-.029-.604.087-.883.116-.28.313-.518.565-.686s.548-.258.851-.258c.406 0 .796.161 1.084.448.287.287.448.676.448 1.081z",
    fill: "#3788B8",
    style: {
      fill: "#c73b24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m462.52 104.34c0 .303-.09.598-.259.85-.168.252-.408.448-.688.563-.28.116-.588.146-.886.087-.297-.059-.57-.205-.784-.419-.215-.214-.361-.486-.42-.783s-.028-.604.088-.884c.116-.279.313-.518.565-.686s.549-.257.852-.257c.201 0 .4.04.586.117.186.076.355.189.497.331.143.142.255.311.332.496.077.186.117.384.117.585z",
    fill: "#3788B8",
    style: {
      fill: "#c73b24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m471.24 104.34c0 .303-.09.598-.258.85-.169.251-.408.447-.688.563s-.588.146-.886.087c-.297-.059-.57-.205-.784-.419-.215-.214-.361-.486-.42-.783s-.028-.604.088-.883c.116-.28.312-.519.564-.687.253-.168.549-.257.852-.257.201 0 .401.04.587.116.185.077.354.19.497.332.142.142.255.311.332.496.077.186.116.384.116.585z",
    fill: "#3788B8",
    style: {
      fill: "#c73b24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m479.96 104.34c0 .303-.09.598-.259.85-.168.251-.407.447-.687.563s-.588.146-.886.087c-.297-.059-.57-.205-.784-.419-.215-.213-.361-.486-.42-.782-.059-.297-.029-.604.087-.884.116-.279.313-.518.565-.686s.548-.258.851-.258c.406 0 .796.161 1.084.448.287.287.449.676.449 1.081z",
    fill: "#3788B8",
    style: {
      fill: "#c73b24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m488.68 104.34c0 .303-.09.599-.258.85-.169.252-.408.448-.688.563-.28.116-.589.146-.886.087s-.571-.204-.785-.418-.36-.487-.419-.784c-.059-.296-.029-.604.087-.883.116-.28.313-.519.565-.687s.549-.257.852-.257c.407 0 .796.162 1.083.448.288.287.449.676.449 1.081z",
    fill: "#3788B8",
    style: {
      fill: "#c73b24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m445.08 113.86c0 .302-.09.598-.258.849-.169.252-.408.448-.688.563-.28.116-.588.147-.886.088-.297-.059-.57-.205-.784-.419-.215-.214-.361-.486-.42-.783s-.029-.604.087-.884c.116-.279.313-.518.565-.686s.548-.257.852-.257c.201 0 .4.039.586.116s.355.189.497.331c.143.142.255.311.332.496.077.186.117.385.117.586z",
    fill: "#3788B8",
    style: {
      fill: "#c73b24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m453.8 113.86c0 .302-.089.598-.258.849-.168.252-.408.448-.688.563-.28.116-.588.146-.885.087s-.57-.204-.785-.418c-.214-.214-.36-.487-.419-.783-.059-.297-.029-.604.087-.884.116-.279.313-.518.565-.686s.548-.257.851-.257c.201 0 .401.039.587.116s.354.189.497.331c.142.142.255.311.332.496.077.186.116.385.116.586z",
    fill: "#3788B8",
    style: {
      fill: "#c73b24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m462.52 113.86c0 .302-.09.598-.259.849-.168.252-.407.448-.688.564-.28.116-.588.146-.885.087-.298-.059-.571-.205-.785-.419-.215-.214-.36-.487-.42-.783-.059-.297-.028-.605.088-.884s.313-.518.565-.686.549-.258.852-.257c.201 0 .4.039.586.116s.355.189.497.331c.143.142.255.311.332.496.077.186.117.385.117.586z",
    fill: "#3788B8",
    style: {
      fill: "#c73b24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m471.24 113.86c0 .302-.09.598-.258.849-.169.252-.408.448-.688.564-.28.115-.588.146-.886.086-.297-.059-.57-.204-.784-.418-.215-.214-.361-.487-.42-.783-.059-.297-.028-.604.088-.884.116-.279.312-.518.564-.686.253-.168.549-.257.852-.257.201 0 .401.039.587.116s.354.189.497.331c.142.142.255.311.332.496.077.186.116.385.116.586z",
    fill: "#3788B8",
    style: {
      fill: "#c73b24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m479.96 113.86c0 .302-.09.598-.258.849-.169.252-.408.448-.688.563-.28.116-.588.147-.886.088-.297-.059-.57-.205-.784-.419-.215-.214-.361-.486-.42-.783-.059-.296-.029-.604.087-.883.116-.28.312-.518.564-.687.252-.168.549-.257.852-.257.201 0 .401.039.587.116s.355.189.497.331.255.311.332.496c.077.186.117.385.117.586z",
    fill: "#3788B8",
    style: {
      fill: "#c73b24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m488.68 113.86c0 .302-.09.598-.258.85-.168.251-.408.447-.688.563s-.588.146-.886.087c-.297-.059-.57-.205-.785-.419-.214-.214-.36-.486-.419-.783s-.029-.604.087-.884c.116-.279.313-.518.565-.686s.549-.258.852-.257c.407 0 .796.161 1.084.448.287.286.448.675.448 1.081z",
    fill: "#3788B8",
    style: {
      fill: "#c73b24"
    }
  }), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "m313.89 319.22s-11.659-58.371-1.042-54.424c10.619 3.947 12.076 49.024 7.287 55.463",
    fill: "#FFC933"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "m313.89 319.22s-11.659-58.371-1.042-54.424c10.619 3.947 12.076 49.024 7.287 55.463",
    stroke: "#FFC933",
    strokeMiterlimit: 10,
    strokeWidth: 1.1924
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "m312.76 321.37s-2.076-23.835-13.501-22.593c-11.425 1.246 5.194 20.727 8.101 22.593",
    fill: "#FFC933"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "m312.76 321.37s-2.076-23.835-13.501-22.593c-11.425 1.246 5.194 20.727 8.101 22.593",
    stroke: "#FFC933",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.1924
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "m299.46 289.04s-3.116 9.327 5.193 7.669c8.31-1.659 5.895-1.97 5.895-1.97",
    fill: "#FFC933"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "m299.46 289.04s-3.116 9.327 5.193 7.669c8.31-1.659 5.895-1.97 5.895-1.97",
    stroke: "#FFC933",
    strokeMiterlimit: 10,
    strokeWidth: 1.1924
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "m315.25 321.16s-2.701-35.648-6.647-37.098c-3.947-1.451-10.594 1.658-9.141 4.974 1.455 3.316 11.218 32.333 11.218 32.333",
    fill: "#FFC933"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "m315.25 321.16s-2.701-35.648-6.647-37.098c-3.947-1.451-10.594 1.658-9.141 4.974 1.455 3.316 11.218 32.333 11.218 32.333",
    stroke: "#FFC933",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.1924
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "m338.87 282.04s2.707 11.217-2.498 14.957c-5.205 3.737-9.16-3.116-9.16-3.116l-.833-12.256",
    fill: "#FFC933"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "m338.87 282.04s2.707 11.217-2.498 14.957c-5.205 3.737-9.16-3.116-9.16-3.116l-.833-12.256",
    stroke: "#FFC933",
    strokeMiterlimit: 10,
    strokeWidth: 1.1924
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "m317.43 320.47s2.915-47.361 13.117-44.454c10.201 2.91 8.327 8.518 8.327 8.518s-2.498-2.284-3.955.623c-1.458 2.909-8.953 36.145-8.953 36.145",
    fill: "#FFC933"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "m317.43 320.47s2.915-47.361 13.117-44.454c10.201 2.91 8.327 8.518 8.327 8.518s-2.498-2.284-3.955.623c-1.458 2.909-8.953 36.145-8.953 36.145",
    stroke: "#FFC933",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.1924
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "m322.02 320.56s4.167-23.56 15.439-21.319c11.271 2.24-6.998 20.189-10.06 21.793",
    fill: "#FFC933"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "m322.02 320.56s4.167-23.56 15.439-21.319c11.271 2.24-6.998 20.189-10.06 21.793",
    stroke: "#FFC933",
    strokeMiterlimit: 10,
    strokeWidth: 1.1924
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "m312.64 267.7s5.471 34.056 3.596 52.751",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.79495
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "m304.72 285.99s7.077 24.718 7.703 33.235",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.79495
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "m299.1 301.98s8.327 12.464 9.576 17.864",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.79495
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "m330.96 279.34s-8.536 25.549-10.826 39.468",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.79495
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "m324.18 320.32-.201-.113c4.738-8.427 11.394-17.167 11.46-17.255l.183.139c-.067.087-6.712 8.817-11.442 17.229z",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.79495
  })), /*#__PURE__*/React.createElement("path", {
    d: "m335.54 319.43h-34.423v7.684h34.423v-7.684z",
    fill: "#3788B8",
    stroke: "#3788B8",
    strokeMiterlimit: 10,
    strokeWidth: 1.1924,
    style: {
      fill: "#c73b24",
      stroke: "#c73b24"
    }
  }), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "m607.77 207.75v-4.544h-3.645c-.297-1.492-.886-2.91-1.734-4.174l2.578-2.572-3.22-3.214-2.578 2.572c-1.267-.846-2.689-1.434-4.184-1.73v-3.635h-4.554v3.635c-1.495.296-2.918.884-4.184 1.73l-2.578-2.572-3.221 3.214 2.578 2.572c-.847 1.264-1.437 2.683-1.734 4.174h-3.645v4.544h3.645c.297 1.492.887 2.91 1.734 4.174l-2.578 2.572 3.221 3.214 2.578-2.572c1.266.846 2.688 1.435 4.184 1.73v3.636h4.554v-3.636c1.495-.296 2.917-.884 4.184-1.73l2.578 2.572 3.22-3.214-2.578-2.572c.848-1.263 1.437-2.682 1.734-4.174h3.645zm-15.06 4.168c-1.277 0-2.525-.377-3.586-1.085-1.062-.707-1.889-1.713-2.378-2.89-.489-1.176-.616-2.471-.368-3.721.249-1.249.864-2.396 1.767-3.297.902-.901 2.052-1.514 3.305-1.763 1.252-.248 2.549-.121 3.729.366 1.179.488 2.188 1.313 2.897 2.372s1.088 2.305 1.088 3.578c0 1.708-.68 3.346-1.891 4.554-1.21 1.207-2.851 1.886-4.563 1.886z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "m461.34 88.252v-3.1866h-2.556c-.208-1.0459-.621-2.0406-1.216-2.9267l1.808-1.8034-2.258-2.2536-1.808 1.8035c-.888-.5935-1.885-1.0059-2.934-1.2132v-2.5494h-3.193v2.5494c-1.049.2075-2.046.6198-2.934 1.2132l-1.807-1.8035-2.259 2.2536 1.808 1.8034c-.595.886-1.008 1.8807-1.216 2.9267h-2.555v3.1866h2.555c.208 1.0461.621 2.0407 1.216 2.9267l-1.808 1.8033 2.259 2.2537 1.807-1.8035c.888.5933 1.886 1.0056 2.934 1.2132v2.5494h3.193v-2.5494c1.049-.2077 2.046-.62 2.934-1.2132l1.808 1.8035 2.258-2.2537-1.808-1.8033c.595-.8861 1.008-1.8807 1.216-2.9267h2.556zm-10.56 2.9224c-.895 1e-4-1.77-.2647-2.514-.7608-.745-.4961-1.325-1.2014-1.668-2.0265-.342-.8251-.432-1.7331-.257-2.609.174-.876.605-1.6807 1.238-2.3123s1.439-1.0617 2.317-1.236 1.788-.0849 2.615.2569c.828.3417 1.534.9205 2.032 1.6631.497.7426.763 1.6156.763 2.5088 0 1.1975-.477 2.346-1.326 3.1928s-2 1.3227-3.2 1.323z",
    fill: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m462.33 295.78c0 1.065-.21 2.119-.618 3.103-.409.984-1.008 1.878-1.762 2.631-.755.753-1.651 1.35-2.637 1.758-.987.407-2.044.617-3.111.616h-58.518c-1.067.001-2.124-.209-3.11-.616-.986-.408-1.882-1.005-2.636-1.758-.755-.753-1.353-1.647-1.762-2.631-.408-.984-.618-2.038-.617-3.103-.001-1.065.209-2.12.617-3.104s1.007-1.878 1.761-2.631c.755-.753 1.651-1.35 2.637-1.758.986-.407 2.043-.617 3.11-.617h58.518c1.068 0 2.125.21 3.111.617.986.408 1.882 1.005 2.637 1.758s1.353 1.647 1.762 2.631c.408.984.618 2.039.618 3.104z",
    fill: "white",
    stroke: "#3788B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.1924,
    style: {
      stroke: "#c73b24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m462.33 249.07c0 1.065-.21 2.12-.618 3.104-.409.984-1.007 1.878-1.762 2.631s-1.651 1.35-2.637 1.758c-.987.407-2.043.617-3.111.616h-58.518c-1.067.001-2.124-.209-3.11-.616-.986-.408-1.882-1.005-2.636-1.758-.755-.753-1.354-1.647-1.762-2.631s-.618-2.039-.617-3.104c-.001-1.064.209-2.119.617-3.103s1.007-1.878 1.762-2.631c.754-.753 1.65-1.35 2.636-1.757.986-.408 2.043-.617 3.11-.617h58.518c1.067 0 2.124.209 3.111.617.986.407 1.882 1.004 2.637 1.757s1.353 1.647 1.762 2.631c.408.984.618 2.038.618 3.103z",
    fill: "white",
    stroke: "#3788B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.1924,
    style: {
      stroke: "#c73b24"
    }
  }), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "m426.95 251.56c0 .511-.101 1.017-.297 1.49-.196.472-.483.901-.845 1.263-.363.362-.793.648-1.266.844-.474.196-.981.296-1.494.296h-28.094c-.512.001-1.02-.1-1.493-.296-.474-.195-.904-.482-1.266-.844-.363-.361-.65-.791-.846-1.263-.196-.473-.297-.979-.296-1.49 0-.512.1-1.018.296-1.49.196-.473.484-.902.846-1.263.362-.362.793-.649 1.266-.844.473-.196.981-.296 1.493-.296h28.094c.513 0 1.02.1 1.493.296.474.195.904.482 1.266.844.363.361.65.79.846 1.263.196.472.297.978.297 1.49z",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "m428.29 297.75c0 .511-.101 1.018-.297 1.49-.196.473-.483.902-.845 1.264-.363.361-.793.648-1.266.844-.474.195-.981.296-1.494.296h-28.094c-.512 0-1.02-.101-1.493-.296-.474-.196-.904-.483-1.266-.844-.363-.362-.65-.791-.846-1.264-.196-.472-.297-.979-.296-1.49-.001-.511.1-1.017.296-1.49.196-.472.483-.901.846-1.263.362-.361.792-.648 1.266-.844.473-.195.981-.296 1.493-.295h28.094c.513-.001 1.02.1 1.493.295.474.196.904.483 1.266.844.363.362.65.791.846 1.263.196.473.297.979.297 1.49z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "m585.79 302.3 4.61 9.773-9.268 2.635-4.274-9.917",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m585.79 302.3 4.61 9.773-9.268 2.635-4.274-9.917",
    stroke: "#3788B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.1924,
    style: {
      stroke: "#c73b24"
    }
  }), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "m527.88 308.48 2.593 10.3-9.124 2.348-.384-11.833",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m527.88 308.48 2.593 10.3-9.124 2.348-.384-11.833",
    stroke: "#3788B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.1924,
    style: {
      stroke: "#c73b24"
    }
  }), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "m537.42 186.05s12.453 7.481 15.961 17.98c3.508 10.5 7.192 56.523 12.979 64.201 5.788 7.678 24.661 32.78 24.661 32.78l-14.453 8.288s-21.608-29.454-26.695-37.984c-5.086-8.531-13.505-47.029-13.505-47.029s-10.873 29.787-11.4 42.037c-.526 12.25 8.239 45.275 8.239 45.275l-14.55.431s-9.123-31.05-10.001-47.106c-.876-16.055 10.348-63.301 10.348-63.301",
    fill: "#353535"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m490.39 212.94c2.587-8.124 3.836-17.603 1.517-27.509-6.577-28.086-14.732-14.699-14.732-7.087 0 0 2.703 15.897 1.249 31.895 2.165 1.544 5.895 3.1 11.966 2.701z",
    fill: "white",
    stroke: "#3788B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.1924,
    style: {
      stroke: "#c73b24"
    }
  }), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "m478.43 210.24c-.902 9.923-3.402 19.885-9.143 26.115l7.103 1.837s9.259-10.341 14.006-25.251c-6.072.399-9.801-1.157-11.966-2.701z",
    fill: "#B78876",
    stroke: "#B78876",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.1924
  })), /*#__PURE__*/React.createElement("path", {
    d: "m475.6 178.09s2.631-15.225 18.679-13.125c16.048 2.101 43.146 21 43.146 21s-9.471 19.424-17.363 19.686c-7.893.263-44.462-15.224-44.462-26.511",
    fill: "#3788B8",
    style: {
      fill: "#c73b24"
    }
  }), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "m470.34 237.01-3.026 5.381-6.314 5.25 14.075.919-1.316-4.2 1.58-6.3",
    fill: "white"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "m470.34 237.01-3.026 5.381-6.314 5.25 14.075.919-1.316-4.2 1.58-6.3",
    stroke: "#3788B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.1924
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "m493.62 192.46s-6.708-11.045-4.077-17.521c2.63-6.474 5.141-6.9 5.141-6.9s-11.587-4.911-13.955 4.931c-2.368 9.844 6.117 16.538 6.117 16.538l6.774 2.952z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "m496.51 189.94s-9.865-20.955 6.358-19.381c13.533 1.314 21.142 15.375 18.862 18.963-2.281 3.588-25.22.418-25.22.418z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "m582.44 322.24.828-1.465 10.134-2.352 1.334 2.66s-29.182 8.201-30.06 6.083c-.281-.677-.513-1.061-.517-1.425l18.281-3.501z",
    fill: "#353535",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.1924
  })), /*#__PURE__*/React.createElement("path", {
    d: "m582.44 322.24-18.281 3.502c-.008-.773-1.431-1.376 2.408-4.534 2.082-1.713 6.928-2.579 8.45-4.167 1.588-1.679 2.835-3.651 3.672-5.804 0 0 4.721 4.153 6.779 2.887 2.06-1.266 4.523-2.507 4.523-2.507l3.411 6.807-10.134 2.352-.828 1.464z",
    fill: "#3788B8",
    stroke: "#3788B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.1924,
    style: {
      fill: "#c73b24",
      stroke: "#c73b24"
    }
  }), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "m521.67 326.04 1.089-1.283 10.396-.405.808 2.864s-30.208 2.567-30.671.321c-.148-.716-.302-1.139-.238-1.496l18.616-.001z",
    fill: "#353535",
    stroke: "#353535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.1924
  })), /*#__PURE__*/React.createElement("path", {
    d: "m521.68 326.04h-18.617c.138-.76-1.143-1.62 3.222-4 2.368-1.29 7.291-1.229 9.086-2.502 1.877-1.351 3.474-3.052 4.701-5.01 0 0 3.854 4.966 6.115 4.11s4.913-1.614 4.913-1.614l2.065 7.327-10.397.406-1.088 1.283z",
    fill: "#3788B8",
    stroke: "#3788B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.1924,
    style: {
      fill: "#c73b24",
      stroke: "#c73b24"
    }
  }), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "m479.68 170.21 6.381.262s2.251 2.791 1.774 5.808c-.46 2.92-2.334 4.495-4.34 4.724-2.006.23-3.288-4.166-3.288-4.166",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m479.68 170.21 6.381.262s2.251 2.791 1.774 5.808c-.46 2.92-2.334 4.495-4.34 4.724-2.006.23-3.288-4.166-3.288-4.166",
    stroke: "#3788B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.1924,
    style: {
      stroke: "#c73b24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m467.97 176.69s8.068 16.099 11.575 11.55c3.509-4.55 2.368-17.5 2.368-17.5s-6.927-1.05-13.943 5.95z",
    fill: "#B78876",
    stroke: "#3788B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.1924,
    style: {
      stroke: "#c73b24"
    }
  }), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "m476.83 175.46 2.719 1.444s-.614-1.531.307-1.925 2.806.744 2.324 2.669l1.841-2.888-2.148-5.468",
    fill: "#353535"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "m482.18 169.34s-.438-7.918-8.199-6.869c-4.519.611-13.724 8.444-6.884 15.269 0 0 11.049 2.274 15.083-8.4z",
    fill: "#353535"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m514.8 204.68s23.328-5.6 22.187-18.636l4.999 3.587s-1.622 7.377-6.829 11.435c-4.79 3.733-11.309 5.749-16.762 5.452l-3.595-1.838z",
    fill: "white",
    stroke: "#3788B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.1924,
    style: {
      stroke: "#c73b24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m475.37 205.86-1.382 6.955 18.624 3.684 1.382-6.955-18.624-3.684z",
    fill: "white",
    stroke: "#3788B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.1924,
    style: {
      stroke: "#c73b24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m448.13 212.68c-3.478-.026-6.932.583-10.19 1.798-.045 0-.09-.006-.135-.006-1.99 0-3.895 1.234-5.658 3.489-1.576 1.471-2.617 3.175-2.953 5.009-4.586 9.886-7.636 27.431-7.636 47.431 0 30.889 7.274 55.929 16.247 55.929.844 0 7.528.38 10.325.38 10.527 0 19.062-5.188 19.062-11.586v-90.857c0-6.399-8.535-11.587-19.062-11.587z",
    fill: "white",
    stroke: "#3788B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.1924,
    style: {
      stroke: "#c73b24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m475.72 270.41c0 30.888-7.274 55.928-16.248 55.928s-16.248-25.04-16.248-55.928c0-30.889 7.274-55.929 16.248-55.929s16.248 25.04 16.248 55.929z",
    fill: "white",
    stroke: "#3788B8",
    strokeMiterlimit: 10,
    strokeWidth: 1.1924,
    style: {
      stroke: "#c73b24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m548.37 269.88c0-3.269 1.302-6.404 3.619-8.715 2.317-2.312 5.46-3.61 8.736-3.61h58.517c3.276 0 6.419 1.298 8.736 3.61 2.317 2.311 3.618 5.446 3.619 8.715-.001 3.269-1.302 6.404-3.619 8.716-2.317 2.311-5.46 3.61-8.736 3.61h-58.517c-3.276 0-6.419-1.299-8.736-3.61-2.317-2.312-3.619-5.447-3.619-8.716z",
    fill: "white",
    stroke: "#3788B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.1924,
    style: {
      stroke: "#c73b24"
    }
  }), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "m624.13 260.44c-.197 2.679-1.404 5.185-3.376 7.014s-4.565 2.846-7.258 2.847h-50.553c-2.135.003-4.221-.636-5.986-1.833-.02.26-.041.52-.041.787 0 2.824 1.125 5.532 3.127 7.529s4.716 3.119 7.547 3.119h50.553c2.284.001 4.507-.73 6.344-2.084 1.837-1.355 3.19-3.261 3.86-5.439.67-2.179.622-4.514-.137-6.663s-2.189-3.999-4.08-5.277z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m522.36 265.34c0-3.025.597-6.02 1.757-8.814s2.86-5.333 5.003-7.472c2.144-2.139 4.689-3.835 7.489-4.993 2.801-1.157 5.803-1.753 8.834-1.752 3.031-.001 6.033.595 8.834 1.752 2.8 1.158 5.345 2.854 7.488 4.993 2.144 2.139 3.844 4.678 5.004 7.472 1.159 2.794 1.756 5.789 1.755 8.814v9.08c.001 3.025-.595 6.02-1.755 8.814-1.16 2.795-2.86 5.334-5.003 7.473-2.144 2.139-4.689 3.835-7.489 4.992-2.801 1.158-5.803 1.753-8.834 1.753s-6.033-.595-8.834-1.753c-2.801-1.157-5.345-2.854-7.489-4.992-2.143-2.139-3.844-4.678-5.003-7.473-1.16-2.794-1.757-5.789-1.757-8.814v-9.08z",
    fill: "white",
    stroke: "#3788B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.1924,
    style: {
      stroke: "#c73b24"
    }
  }), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "m555.05 283.27c-2.737 0-5.446-.537-7.975-1.582-2.528-1.045-4.825-2.576-6.76-4.507-1.935-1.93-3.469-4.222-4.516-6.745-1.047-2.522-1.586-5.226-1.585-7.956v-8.197c-.004-2.768.549-5.509 1.624-8.06-3.179 1.82-5.821 4.445-7.658 7.61-1.836 3.165-2.803 6.758-2.802 10.415v8.198c.001 4.8 1.666 9.452 4.713 13.167 3.047 3.714 7.289 6.262 12.005 7.212 4.716.949 9.616.241 13.868-2.004 4.253-2.245 7.596-5.889 9.462-10.314-3.156 1.814-6.735 2.767-10.376 2.763z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m519.11 226.42h-46.164c-3.675-.003-7.308.774-10.659 2.28-8.741 18.798-12.775 60.766.002 82.368 3.35 1.506 6.983 2.283 10.657 2.28h46.164c3.415 0 6.797-.671 9.953-1.975 3.155-1.303 6.022-3.215 8.437-5.624 2.416-2.41 4.331-5.27 5.638-8.418 1.308-3.148 1.98-6.523 1.98-9.93v-35.033c0-3.408-.673-6.782-1.98-9.931-1.307-3.148-3.222-6.008-5.638-8.418-2.415-2.409-5.282-4.321-8.437-5.625-3.156-1.304-6.538-1.975-9.953-1.974z",
    fill: "white",
    stroke: "#3788B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.1924,
    style: {
      stroke: "#c73b24"
    }
  }), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "m535.58 297.06h-41.485c-3.302.002-6.566-.696-9.577-2.048-9.534-16.119-8.647-44.846-3.578-63.805h-6.437c-3.302-.002-6.567.696-9.579 2.049-7.855 16.893-11.48 54.608.002 74.022 3.011 1.352 6.276 2.05 9.577 2.047h41.485c4.227.002 8.374-1.141 12.002-3.305 3.627-2.164 6.598-5.27 8.596-8.985-.335.014-.669.025-1.006.025z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m509.18 210.05c1.019-6.047 1.421-19.559-.548-26.187-5.399-18.183-13.387-6.941-13.387-.225 0 0 .888 12.772.295 26.932 4.551.364 9.13.189 13.64-.52z",
    fill: "white",
    stroke: "#3788B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.1924,
    style: {
      stroke: "#c73b24"
    }
  }), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "m495.54 210.57c-.48 11.449-1.964 25.051-8.669 32.327l5.09 1.437s13.985-15.102 17.219-34.285c-4.51.71-9.089.885-13.64.521z",
    fill: "#B78876",
    stroke: "#B78876",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.1924
  })), /*#__PURE__*/React.createElement("path", {
    d: "m511.55 209.26h-19.207v8.049h19.207v-8.049z",
    fill: "white",
    stroke: "#3788B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.1924,
    style: {
      stroke: "#c73b24"
    }
  }), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "m492.97 242.69-5.52-2.141c-.289.047-.57.13-.837.249-.412.188-.263 1.527-.263 1.527s-3.326 2.34-4.898 4.856-4.809 4.299-3.529 4.862c1.283.565 2.301-1.737 2.829-1.2.264.269-.503 2.442-1.719 4.371-1.216 1.928-2.88 3.61-1.898 3.813 1.963.406 5.68-5.847 5.68-5.847s-.746 2.2-1.675 4.44c-.995 2.405-2.143 4.877-.994 5.327.992.389 1.882-1.832 3.053-3.929.784-1.373 1.647-2.7 2.584-3.975 0 0-2.497 7.477-1.389 7.049 1.107-.428 3.182-7.134 3.645-6.942.463.191-.82 4.954-.01 4.853.811-.102 3.304-8.167 3.304-8.167s2.121-4.462 1.23-7.298c0 0 1.355-1.075.407-1.848z",
    fill: "#FFC933"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m553.84 197.79c.204.318.343.673.41 1.044.066.372.059.753-.022 1.122s-.234.718-.451 1.028c-.216.309-.491.573-.81.777l-6.551 4.185c-.319.203-.674.342-1.047.409-.372.066-.754.059-1.124-.022-.369-.081-.719-.234-1.03-.45-.31-.216-.575-.49-.779-.808l-8.544-13.315c-.204-.318-.343-.673-.41-1.045-.066-.371-.059-.752.022-1.121s.234-.718.451-1.028c.216-.309.491-.574.81-.777l6.551-4.185c.319-.203.675-.342 1.047-.409.373-.066.755-.059 1.124.022.37.081.72.234 1.03.45.311.215.575.49.779.808l8.544 13.315z",
    fill: "white",
    stroke: "#3788B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.1924,
    style: {
      stroke: "#c73b24"
    }
  }), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "m537.19 196.23s8.257-.326 11.749-6.481l-11.749 6.481z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m537.19 196.23s8.257-.326 11.749-6.481",
    stroke: "#3788B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.1924,
    style: {
      stroke: "#c73b24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m533.72 146.34c0 1.194-.236 2.376-.694 3.479s-1.129 2.105-1.975 2.949c-.846.845-1.851 1.514-2.956 1.971-1.106.457-2.291.692-3.488.692h-30.374c-2.417 0-4.734-.958-6.443-2.663s-2.669-4.017-2.669-6.428c0-2.412.96-4.724 2.669-6.429s4.026-2.663 6.443-2.663h30.374c1.197 0 2.382.235 3.488.692 1.105.457 2.11 1.127 2.956 1.971s1.517 1.846 1.975 2.949c.458 1.104.694 2.286.694 3.48z",
    fill: "#3788B8",
    style: {
      fill: "#c73b24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m189.76 130.23h-44.178c-7.32 0-13.254 6.746-13.254 15.068s5.934 15.069 13.254 15.069h44.178c.395 0 .785-.024 1.171-.062h12.083v-15.007c0-8.322-5.934-15.068-13.254-15.068z",
    fill: "#3788B8",
    style: {
      fill: "#c73b24"
    }
  }), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "m502 146.04c0 .267-.079.527-.228.749-.148.221-.359.394-.605.496-.247.102-.519.129-.78.077-.262-.052-.503-.181-.692-.369-.188-.189-.317-.429-.369-.69s-.025-.532.077-.778.275-.457.497-.605.483-.227.75-.227c.177 0 .353.035.517.103s.312.167.438.292c.125.125.225.274.292.437.068.163.103.339.103.515z",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "m510.77 146.04c0 .267-.079.527-.227.749-.149.221-.359.394-.606.496s-.518.129-.78.077-.503-.181-.691-.369c-.189-.189-.318-.429-.37-.69s-.025-.532.077-.778.275-.457.497-.605.484-.227.751-.227c.177 0 .352.035.516.103s.313.167.438.292.225.274.293.437.102.339.102.515z",
    fill: "white"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "m519.55 146.04c-.001.267-.08.527-.228.749-.148.221-.359.394-.606.496s-.518.128-.78.076-.502-.18-.691-.368c-.189-.189-.317-.429-.369-.69s-.026-.532.077-.778c.102-.246.275-.457.497-.605s.483-.227.75-.227c.177 0 .353.035.516.103.164.068.313.167.438.292.126.125.225.274.293.437s.103.339.103.515z",
    fill: "white"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "m155.63 148.09h-1.576l-.656 4.003h-1.947l.655-4.003h-2.172v-1.787h2.466l.43-2.578h-2.163v-1.786h2.457l.675-4.063h1.938l-.666 4.063h1.576l.676-4.063h1.947l-.675 4.063h2.261v1.786h-2.555l-.43 2.578h2.241v1.787h-2.535l-.656 4.003h-1.947l.656-4.003zm-1.283-1.787h1.576l.431-2.578h-1.576l-.431 2.578z",
    fill: "white"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "m169.13 148.09h-1.576l-.656 4.003h-1.947l.655-4.003h-2.172v-1.787h2.466l.43-2.578h-2.162v-1.786h2.456l.675-4.063h1.938l-.665 4.063h1.575l.676-4.063h1.947l-.675 4.063h2.261v1.786h-2.555l-.43 2.578h2.241v1.787h-2.535l-.656 4.003h-1.947l.656-4.003zm-1.283-1.787h1.576l.431-2.578h-1.576l-.431 2.578z",
    fill: "white"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "m182.63 148.09h-1.575l-.656 4.003h-1.947l.655-4.003h-2.172v-1.787h2.466l.43-2.578h-2.162v-1.786h2.456l.675-4.063h1.938l-.665 4.063h1.575l.676-4.063h1.947l-.675 4.063h2.261v1.786h-2.555l-.43 2.578h2.241v1.787h-2.535l-.656 4.003h-1.947l.655-4.003zm-1.282-1.787h1.576l.431-2.578h-1.576l-.431 2.578z",
    fill: "white"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "m617.49 258.07c-.065-.867-.13-1.683-.188-2.456-.061-.772-.068-1.497-.104-2.167-.032-.668-.066-1.286-.062-1.843-.012-.732-.021-1.346-.021-1.863 1.278-1.252 10.439-10.953 2.908-24.738 0 0-13.914 10.048-3.159 24.733-.078.507-.165 1.119-.249 1.841-.141 1.115-.245 2.474-.349 4.038-.034.781-.068 1.614-.102 2.49-.053.881.081 1.8.12 2.762.055.749.097 1.532.154 2.33-.515-.676-1.195-1.566-1.88-2.462-.343-.448-.687-.902-1.012-1.319-.125-.153-.245-.301-.363-.446 2.082-19.099-11.778-21.794-11.778-21.794.341 20.139 8.514 21.885 11.036 21.942.184.227.381.465.589.72.322.418.666.866 1.004 1.311.684.894 1.365 1.787 1.877 2.459.075.078.106.178.189.235.079.062.156.119.225.175.076.055.129.095.191.143.102.94.209 1.902.312 2.894.064.549.11 1.105.19 1.666.087.557.177 1.123.265 1.694.183 1.143.368 2.312.555 3.499.234 1.195.455 2.368.726 3.583.129.574.266 1.154.399 1.733-.076-.153-.161-.303-.254-.447-.163-.271-.329-.545-.498-.822-.329-.549-.662-1.103-.974-1.619-.34-.502-.657-.968-.929-1.371-.06-.098-.125-.192-.196-.281-.084-.079-.165-.147-.237-.219-.07-.062-.127-.103-.191-.156-.407-2.968-2.917-14.684-17.386-17.335 0 0-.926 17.088 17.241 18.008.012.031.025.058.034.091.057.098.121.192.191.28.269.394.577.853.913 1.343.304.51.636 1.052.962 1.601.162.271.327.542.49.81.159.259.304.527.433.802.266.536.51 1.033.723 1.457.041.107.094.208.157.303.042.052.083.099.125.15.527 2.223 1.063 4.462 1.459 6.72.249 1.24.395 2.492.565 3.732.08.622.109 1.249.167 1.866.045.623.114 1.243.111 1.861.002.141.005.276.007.419-.042-.085-.083-.17-.132-.255-.2-.391-.421-.771-.661-1.139-.227-.399-.527-.766-.8-1.165-.3-.372-.604-.757-.94-1.114-.326-.312-.63-.65-.983-.932.086-.029.167-.047.253-.075 0 0-4.726-14.109-20.04-11.477 0 0 3.601 16.138 19.018 11.779.086.07.169.136.252.205.356.298.693.617 1.01.955.319.34.609.708.9 1.064.26.379.547.732.764 1.116.24.37.453.737.637 1.095.198.354.351.701.503 1.018.084.157.117.327.204.464.013.02.024.041.036.061.003.557.001 1.11-.039 1.661-.027.606-.048 1.207-.075 1.805-.051.599-.123 1.193-.183 1.778-.058.589-.121 1.169-.181 1.747-.091.576-.182 1.144-.275 1.705-.188 1.126-.343 2.229-.6 3.285-.238 1.06-.464 2.092-.684 3.094-.065.233-.126.462-.191.693-.054-.224-.115-.45-.189-.673-.291-.903-.708-1.759-1.241-2.544-.057-.072-.083-.17-.156-.225-.073-.06-.143-.11-.207-.159-.089-.065-.161-.11-.236-.16-.137-1.565-1.577-13.032-14.287-14.336 0 0-.815 15.027 14.009 14.522.032.088.063.175.099.282.027.073.053.153.081.235.029.079.105.134.146.214.497.733.886 1.532 1.158 2.374.148.446.254.905.316 1.37.035.212.057.426.066.641.001.032.002.059 0 .089-.048.18-.095.36-.143.537-.126.455-.25.907-.372 1.346-.129.433-.276.853-.375 1.277-.209.843-.408 1.641-.596 2.394-.355 1.512-.745 2.806-1.058 3.877-.617 2.147-.948 3.386-.948 3.386s.525-1.163 1.418-3.217c.444-1.031.997-2.275 1.54-3.741.197-.5.402-1.031.616-1.578.047-.023.088-.042.142-.068.074-.037.155-.077.24-.119.086-.036.135-.128.217-.188.15-.149.313-.285.486-.407.186-.127.387-.261.591-.399.208-.138.411-.293.635-.427.23-.112.467-.234.702-.355.228-.129.466-.239.712-.329.243-.095.484-.183.708-.267.224-.083.453-.151.686-.203.22-.052.423-.124.615-.152.095-.007.189-.023.282-.048.042-.023.08-.04.124-.06 2.618.693 14.738 3.092 22.782-9.521 0 0-15.364-7.198-23.089 8.933-.071.012-.146.036-.227.042-.206.033-.422.105-.656.16-.246.056-.487.128-.724.215-.245.09-.499.185-.757.285-.259.098-.51.214-.753.347-.249.126-.494.254-.74.38-.238.138-.453.299-.672.443-.214.146-.424.289-.622.426-.095.058-.182.126-.262.203.249-.717.415-1.494.643-2.28.251-.929.514-1.895.788-2.897.219-1.017.453-2.065.69-3.14.262-1.075.422-2.201.613-3.348.091-.571.185-1.152.28-1.736.033-.302.065-.611.096-.917.036-.013.066-.027.104-.039.063-.028.087-.1.144-.141.391-.389.913-.907 1.429-1.426.521-.519 1.039-1.038 1.429-1.431.031-.037.07-.062.1-.093 3.332-.483 14.568-3.138 17.257-17.183 0 0-17.182-1.055-18.182 17.16-.327.328-.7.704-1.074 1.074-.388.385-.773.77-1.108 1.103.06-.566.128-1.134.175-1.714.026-.614.052-1.233.079-1.853.089-1.245.03-2.504.011-3.78.001-.634-.071-1.268-.115-1.908-.059-.636-.087-1.282-.17-1.92-.131-.948-.26-1.901-.415-2.848.018-.104.03-.209.036-.315.071-.595.099-1.29.23-2.038.12-.745.231-1.541.391-2.334.287-1.584.643-3.159.916-4.34.039-.139.072-.28.096-.423.004-.076.009-.15.012-.224 1.666-.826 13.858-7.449 8.498-22.35 0 0-16.887 10.382-8.974 22.013-.006.015-.012.029-.019.042-.053.115-.106.236-.165.366-.053.13-.055.279-.099.426-.278 1.187-.634 2.769-.923 4.37-.163.796-.274 1.606-.394 2.361-.007.054-.01.107-.019.162-.411-2.085-.907-4.132-1.382-6.151-.296-1.219-.566-2.427-.835-3.613-.267-1.187-.494-2.407-.722-3.555-.185-1.17-.367-2.326-.545-3.455-.09-.564-.177-1.122-.267-1.674-.076-.553-.121-1.103-.184-1.643-.104-.971-.203-1.911-.303-2.831.035-.266.086-.53.155-.789.074-.339.165-.674.275-1.003.1-.334.219-.662.356-.983.117-.321.279-.621.413-.92.269-.534.572-1.051.907-1.548.064-.114.159-.199.21-.309.051-.112.102-.22.144-.318.002-.007.006-.011.008-.02 2.653-.821 11.163-4.324 8.903-14.854 0 0-12.196 2.859-9.695 14.935-.036.067-.078.131-.125.191-.35.521-.667 1.063-.95 1.623-.142.317-.308.628-.434.968-.123.295-.231.598-.328.907-.023-.392-.044-.779-.069-1.158-.075-.949-.079-1.858-.132-2.722z",
    fill: "#FFC933"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenanceIllustrationEon);
export default __webpack_public_path__ + "static/media/maintenanceIllustrationEON.475338d08c53819d0191130bfdcfad26.svg";
export { ForwardRef as ReactComponent };